module.exports = __webpack_public_path__ + "static/media/networking-logo.e5056fc1.png";